import React, {useState} from "react";
import DataTableBase from "../../../../ui/data_tables/DataTableBase";
import {Image} from "react-bootstrap";

import '../../../../../assets/sass/pages/matches-and-events/datatables/upcoming-matches-datatable.scss';
import {Link} from "react-router-dom";
import {gql, useQuery} from "@apollo/client";
import dustinWilliamsonAvatar from "../../../../../assets/img/demo/dustin-williamson-avatar.png";
import eduardoMilesAvatar from "../../../../../assets/img/demo/eduardo-miles-avatar.png";
import liverpoolLogo from "../../../../../assets/img/demo/liverpool-logo.png";
import Tools from "../../../../../Tools";
import evertonLogo from "../../../../../assets/img/demo/everton-logo.png";
import chelseaLogo from "../../../../../assets/img/demo/chelsea-logo.png";
import annFloresAvatar from "../../../../../assets/img/demo/ann-flores-avatar.png";


import moment from 'moment';

class UpcomingMatchesDataTable extends DataTableBase {

    /**
     * Returns the table columns configurations.
     * @returns {Array} the columns configurations.
     */
    columnsConfig = () => [
        {
            dataField: 'match',
            text: 'Match',
            renderer: this.renderMatch,
        }, {
            dataField: 'topScorersEverton',
            text: 'Top Scorers Everton',
            renderer: this.renderAvatars,
        }, {
            dataField: 'topScorersChelsea',
            text: 'Top Scorers chelsea',
            renderer: this.renderAvatars,
        }, {
            dataField: 'mostAssistsEverton',
            text: 'Top Scorers Everton',
            renderer: this.renderAvatars,
        }, {
            dataField: 'mostAssistsChelsea',
            text: 'Most Assists Chelsea',
            renderer: this.renderAvatars,
        }, {
            dataField: 'SaveToMyCalendar',
            text: '',
            renderer: this.renderSaveLink
        }
    ];

    renderMatch = (rowData) => {
        const {match} = rowData;
        const {datetime, stadium, team1, team2, league} = match;
        const {name: team1Name, logo: team1Logo} = team1;
        const {name: team2Name, logo: team2Logo} = team2;

        const vsText = `VS`;
        const team1VsTeam2 = `${team1Name} ${vsText} ${team2Name}`;
        const datetimeStadium = `${datetime} | ${stadium}`;

        return (
            <div className="match--cel">
                <div className="datetime-stadium"> {datetimeStadium} </div>
                <div className="d-flex flex-row">
                    <div className="logos">
                        <Image className="logo" src={team1Logo}/>
                        <span className="vs"> {vsText} </span>
                        <Image className="logo" src={team2Logo}/>
                    </div>
                    <div className="teams-league">
                        <div className="teams-names"> {team1VsTeam2}</div>
                        <div className="league"> {league}</div>
                    </div>
                </div>
            </div>
        );
    };

    renderAvatars = (rowData, dataField) => {
        const avatars = rowData[dataField];

        return (
            <div className="avatars--cell">
                {avatars.map(avatar => <Image className="avatar" src={avatar}/>)}
            </div>
        );
    };

    renderSaveLink = (rowData) => {
        const text = `Save to my calendar`;
        const {match} = rowData;
        const {datetime, stadium, team1, team2, league} = match;
        const {name: team1Name, logo: team1Logo} = team1;
        const {name: team2Name, logo: team2Logo} = team2;

        const vsText = `VS`;
        const team1VsTeam2 = `${team1Name} ${vsText} ${team2Name}`;
        const datetimeStadium = `${datetime} | ${stadium}`;

        return (
            <div className="link" onClick={() => this.saveEventToGoogleCalender(team1VsTeam2, datetimeStadium)}> {text} </div>
        );
    };

    saveEventToGoogleCalender = (title, description) => {
        window.open(this.googleCalendarEventLink(title, description), '_blank');
    };

    googleCalendarEventLink = (title, description) => {
        const google_calendar = 'https://www.google.com/calendar/render';
        return `${google_calendar}?action=TEMPLATE&text=${title}&details=${description}&dates=20200414T114700Z%2F20200415T114800Z`;
    };

    /**
     *  On load, called to load the auth2 library and API client library.
     */
    handleClientLoad = () => {
    };


    selectRowConfig = () => {
        return {
            enable: false,
        };
    };

    expandRowConfig = () => {
        return {
            enable: false,
        };
    };

    extraClasses = {
        table: 'upcoming-matches-datatable',
    };

}

const UpcomingMatchesDataTableDataWrapper = props => {
    const query = gql`
        query getUpcomingMatches (
            $q: String,
            $regions: [String!],
            $countries: [String!],
            $competitions: [String!],
            $teams: [String!],
            $stadiums: [String!],
            $skip: Int,
            $take: Int){

            matches: getUpcomingMatches (
                q: $q,
                regions: $regions,
                countries: $countries,
                competitions: $competitions,
                teams: $teams,
                stadiums: $stadiums,
                skip: $skip,
                take: $take,
            ){
                total
                filteredFrom
                results{
                    ...matchField
                }
            }
        }

        fragment matchField on MatchModel{
            homeTeam{
                team{
                    name
                }
            }

            awayTeam{
                team{
                    name
                }
            }

            eventDate
            competition{
                name
            }
            stadium{
                name
            }
        }
    `;


    const formatter = matches => {
        if (!matches)
            return [];

        return matches.map(match => {
            const {team: homeTeam} = match.homeTeam;
            const {team: awayTeam} = match.awayTeam;
            const {competition, eventDate, stadium} = match;

            const dataFormat = moment().calendar((eventDate), {
                sameDay: '[Today] HH:mm',
                nextDay: '[Tomorrow] HH:mm',
                nextWeek: 'dddd HH:mm',
                sameElse: 'dddd DD/MM/YYYY HH:mm'
            });

            return {
                match: {
                    datetime: dataFormat,
                    stadium: stadium.name,
                    team1: {
                        name: homeTeam.name,
                        logo: evertonLogo,
                    },
                    team2: {
                        name: awayTeam.name,
                        logo: chelseaLogo,
                    },
                    league: competition.name,
                },
                topScorersEverton: [annFloresAvatar, annFloresAvatar, annFloresAvatar],
                topScorersChelsea: [annFloresAvatar, annFloresAvatar, annFloresAvatar],
                mostAssistsEverton: [annFloresAvatar, annFloresAvatar, annFloresAvatar],
                mostAssistsChelsea: [annFloresAvatar, annFloresAvatar, annFloresAvatar],
                SaveToMyCalendar: '#',
            }
        })
    };

    // Get filters values from props.
    const {regions, countries, competitions, teams, venues, search: _q} = props;
    const [q, setQ] = useState(_q);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageSize: 10
    });

    // Delay search process.
    Tools.delay(() => setQ(_q), 500);

    const {loading: fetchingLoading, error, data} = useQuery(query, {
        variables: {
            q: Tools.convertEmptyToNull(q),
            regions: Tools.convertEmptyToNull(regions),
            countries: Tools.convertEmptyToNull(countries),
            competitions: Tools.convertEmptyToNull(competitions),
            teams: Tools.convertEmptyToNull(teams),
            stadiums: Tools.convertEmptyToNull(venues),
        }
    });

    const loading = fetchingLoading || q !== _q;

    // Format data.
    const rows = formatter(data?.matches?.results);
    const filteredFrom = data?.matches?.filteredFrom;
    const total = data?.matches?.total;

    const paginationProps = {
        currentPage: pagination.currentPage,
        pageSize: pagination.pageSize,
        total: total,
        filteredFrom: filteredFrom,
    };

    const handlersProp = {
        onPageChange: (pagination) => setPagination(pagination),
        // onSort: (field, order) => setSort(field, order),
    };

    return (
        <UpcomingMatchesDataTable
            loading={loading}
            error={error}
            rows={rows}
            {...paginationProps}
            {...handlersProp}
        />
    );
};

export default UpcomingMatchesDataTableDataWrapper;
